import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { AppStoreProvider } from './stores';
import { TabModel } from '../common/types/TabModel';
import { ContractIngestionAppScreen } from './screens';

interface Props {
    tab: TabModel;
}

const ContractIngestionApp: React.FC<Props> = ({ tab }) => {
    return (
        <AppStoreProvider tab={tab}>
            <ContractIngestionAppScreen />
        </AppStoreProvider>
    );
};

export default observer(ContractIngestionApp);
